import { PropsWithChildren, createContext, useContext } from 'react';

const BookingContext = createContext<{
  manual: boolean;
}>({
  manual: false,
});

type Props = PropsWithChildren<{
  manual: boolean;
}>;

export function BookingProvider({ manual, children }: Props): React.ReactElement {
  return <BookingContext.Provider value={{ manual }}>{children}</BookingContext.Provider>;
}

export function useBookingContext() {
  return useContext(BookingContext);
}
